import {Component} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';

import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
    selector: 'app-no-access',
    imports: [
    FaIconComponent
],
    templateUrl: './no-access.component.html',
    styleUrls: ['./no-access.component.css']
})
export class NoAccessComponent {

  constructor(public keycloakService: KeycloakService) {
  }

  logout(): void {
    this.keycloakService.logout().then(a => {
    });
  }

}
